import type React from "react";
import type { LocalizedText } from "@shared/schemas/localized-text.schemas";
import { LocalizedTextUtils } from "@shared/utils/localized-text.utils";
import { i18n } from "@frontend/i18n";

export interface BioSectionProps {
  readonly bio: LocalizedText;
}

export function BioSection({ bio }: BioSectionProps): React.JSX.Element {
  return (
    <p
      className="text-pds-xs text-foreground leading-normal"
      data-testid="bio-section"
    >
      {LocalizedTextUtils.resolve(bio, i18n.getLocale())}
    </p>
  );
}
